{
  "min": 180,
  "max": 600,
  "R": [0, 0, 113, 255],
  "G": [0, 0, 109, 250],
  "B": [0, 0, 101, 245],
  "A": [0, 0, 100, 160],
  "I": [0, 1, 128, 255]
}
